import { useTranslation } from 'react-i18next'

import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../Checkbox'
import { CalendarRailBlock } from '../CalendarRailBlock'

import {
  QA_NAME_CALENDAR_RAIL_CANCELLED_APPOINTMENTS,
  QA_NAME_CALENDAR_RAIL_DONE_TASKS,
} from './CalendarRailView.constants'

import * as styles from './CalendarRailView.module.css'

function CalendarRailView({
  includeCancelledAppointments,
  includeDoneTasks,
  onChange,
}) {
  const { t } = useTranslation()

  function handleChangeDoneTasks(isChecked) {
    onChange({ include_done_tasks: isChecked })
  }

  function handleChangeCancelledAppointments(isChecked) {
    onChange({ include_cancelled_appointments: isChecked })
  }

  return (
    <CalendarRailBlock title={t('Calendar.RailViewKey')}>
      <Checkbox
        checked={includeDoneTasks}
        label={t('Calendar.ShowDoneTasksKey')}
        labelTitleClassName={styles.title}
        qaName={QA_NAME_CALENDAR_RAIL_DONE_TASKS}
        size={CHECKBOX_SIZE.small}
        type={CHECKBOX_TYPE.action}
        onChange={handleChangeDoneTasks}
      />
      <Checkbox
        checked={includeCancelledAppointments}
        label={t('Calendar.ShowCancelledAppointmentsKey')}
        labelTitleClassName={styles.title}
        qaName={QA_NAME_CALENDAR_RAIL_CANCELLED_APPOINTMENTS}
        size={CHECKBOX_SIZE.small}
        type={CHECKBOX_TYPE.action}
        onChange={handleChangeCancelledAppointments}
      />
    </CalendarRailBlock>
  )
}

export default CalendarRailView
